<script setup lang="ts">
import { computed } from "vue";
import VChips from "@magnit/core/src/components/VChips/VChips.vue";
import VText from "@magnit/core/src/components/VText/VText.vue";
import type {
  IShopSelectDisplayFilter,
  IShopSelectShopFilterProps,
} from "../types";

const props = withDefaults(defineProps<IShopSelectShopFilterProps>(), {
  filters: () => [],
});
const emit = defineEmits<{
  "toggle:filter": [
    payload: { filter: IShopSelectDisplayFilter; value: boolean },
  ];
}>();
const displayList = computed(() =>
  props.filters.map((s, key) => ({
    ...s,
    key,
    className: { "select-shop__shop-filters--chip-active": s.active },
  })),
);
const allShopsActive = computed(() =>
  props.filters.find((i) => i.type === null && i.active === true),
);
const handleChipClick = (e: Event, filter: IShopSelectDisplayFilter) => {
  if (filter.type === null && allShopsActive.value) {
    e.preventDefault();
    return;
  }
  const value = !filter.active;
  emit("toggle:filter", { filter, value });
};
</script>

<template>
  <section class="select-shop__shop-filters" data-test-id="shops-filters">
    <VChips
      v-for="single of displayList"
      :key="single.key"
      wrapper-class="select-shop__shop-filters--chip"
      :model-value="single.active"
      @click="(e: Event) => handleChipClick(e, single)"
    >
      <VText
        class="select-shop__shop-filters--text"
        :color="single.color"
        font="body-small-accent"
        >{{ single.label }}</VText
      >
    </VChips>
  </section>
</template>

<style lang="postcss" scoped>
.select-shop__shop-filters {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: var(--pl-unit-x2);
  padding: var(--pl-unit-x2) 0;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (--pl-viewport-from-ml) {
    flex-wrap: wrap;
    overflow-x: hidden;
  }

  &--chip {
    margin: 0;

    &:last-child {
      margin-right: var(--pl-unit-x5);
    }
  }

  &--text {
    white-space: nowrap;
  }
}
</style>
